// ============================================================================
// Plate utilities — support the classic Moroccan structured format AND the new
// flexible formats (numbers only, numbers + city/series code) while staying
// fully backward compatible with existing records.
//
//   Classic structured : "12345 - أ - 67"
//   WW / temporary      : "12345 - WW"  or "12345 - WW - 7"
//   Numbers only        : "123456"
//   Numbers + code      : "123456 WW"   (free, stored exactly as typed)
// ============================================================================

// Arabic letters used on standard Moroccan plates.
export const PLATE_LETTERS = ['أ', 'ب', 'د', 'هـ', 'ط', 'ش', 'و', 'ر', 'م', 'ج', 'س', 'ع', 'ف', 'ك', 'ي', 'ح', 'خ'];

// A plate that was saved with the structured " - " separators is "standard".
// Anything else (numbers only, "123456 WW", custom text) is "free".
export function parsePlate(plate) {
  const raw = (plate || '').toString().trim();
  if (!raw) return { mode: 'standard', num: '', letter: 'أ', province: '', free: '' };

  const parts = raw.split(/\s*-\s*/);

  // WW / temporary plate written in the structured form.
  if (parts.length >= 2 && /^ww$/i.test(parts[1])) {
    return { mode: 'ww', num: parts[0] || '', letter: 'WW', province: parts[2] || '', free: raw };
  }
  // Classic structured: number - arabic letter - province.
  if (parts.length === 3 && PLATE_LETTERS.includes(parts[1])) {
    return { mode: 'standard', num: parts[0] || '', letter: parts[1], province: parts[2] || '', free: raw };
  }
  // Everything else → free format, kept exactly as entered.
  return { mode: 'free', num: raw, letter: 'أ', province: '', free: raw };
}

// Build the stored plate string from the structured parts.
export function buildStructuredPlate({ num, letter, province }) {
  const n = (num || '').trim();
  if (!n) return '';
  if (letter === 'none' || !letter) return n;                 // numbers only
  if (letter === 'WW') return province ? `${n} - WW - ${province}` : `${n} - WW`;
  return province ? `${n} - ${letter} - ${province}` : `${n} - ${letter}`;
}

// Normalize a plate (or a search term) for comparison: lowercase and strip all
// separators/spaces so "123456 WW", "123456-WW" and "123456WW" all match, and a
// search for "123456" finds a plate that also carries a city code.
export function normalizePlate(s) {
  return (s || '').toString().toLowerCase().replace(/[\s\-_.]/g, '');
}

// True if `plate` matches `query` with or without the city/series code.
export function plateMatches(plate, query) {
  const q = normalizePlate(query);
  if (!q) return true;
  return normalizePlate(plate).includes(q);
}
